'use client'
/* eslint-disable jsx-a11y/alt-text */
import { useState } from 'react'
import { Image } from 'react-datocms'
import { Button, cn, LeftArrow } from '@desoutter/uikit'
import { ArticleCarouselFragment } from './ArticleCarousel.generated'

type ArticleCarouselProps = {
	fragment: ArticleCarouselFragment
}
export default function ArticleCarousel({ fragment }: ArticleCarouselProps) {
	const [currentImageIndex, setCurrentImage] = useState(0)

	return (
		<>
			<div className="relative mt-8">
				<Button
					color="tertiary"
					title="backward"
					className="absolute top-1/2 left-6 stroke-gray-900 z-20"
					icon={LeftArrow}
					onClick={() =>
						setCurrentImage(
							currentImageIndex === 0
								? currentImageIndex
								: currentImageIndex - 1,
						)
					}
				/>
				<Button
					color="tertiary"
					title="forward"
					className="absolute top-1/2 right-6 z-20"
					onClick={() =>
						setCurrentImage(
							currentImageIndex + 1 === fragment.images.length
								? currentImageIndex
								: currentImageIndex + 1,
						)
					}
				/>
				<div className="relative">
					<Image
						objectFit="cover"
						data={fragment.images[currentImageIndex].responsiveImage}
						className="rounded-2xl"
					/>
				</div>
			</div>
			<div className="hidden sm:flex mt-4 mb-8 gap-1 md:gap-4">
				{fragment.images.map((image) => (
					<div
						className="relative h-32 w-32 cursor-pointer"
						key={image.id}
						onClick={() => setCurrentImage(fragment.images.indexOf(image))}
					>
						<Image
							data={image.responsiveImage}
							layout="fill"
							objectFit="cover"
							className={cn(
								'relative rounded-2xl z-10',
								fragment.images[currentImageIndex].id === image.id
									? ''
									: 'before:content-[""] before:absolute before:top-0 before:w-full before:h-full before:rounded-xl before:bg-white before:opacity-40 before:z-10',
							)}
						/>
					</div>
				))}
			</div>
		</>
	)
}
